import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'mwp-agent-sass-containers',
    templateUrl: './sass-containers.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SassContainersComponent {
    constructor(){
    }

    
}